
'use strict'

import lazysizes from 'lazysizes' // eslint-disable-line no-unused-vars
import picturefill from 'picturefill' // eslint-disable-line no-unused-vars
import es6Promise from 'es6-promise'
import FastClick from 'fastclick'
import svgInliner from 'svg-inliner-util'

import createFocusStylesObserver from './utilities/focusStylesObserver'
import dom from './utilities/dom'
import { trackEvent } from './utilities/tracker'

import simpleModal from './components/simpleModal'
import bgVideo from './components/bgVideo'
import carousel from './components/carousel'


/***
 * Tracking
 *
 */
const setClickTracking = () => {
  document.addEventListener('click', (event) => {
    let attribute = 'data-track-click'
    let matchedElem = dom.eventAttributeMatch(event.target, event.currentTarget, attribute)

    if (matchedElem) {
      trackEvent(
        matchedElem.getAttribute('data-track-category'),
        matchedElem.getAttribute('data-track-click') || 'Click',
        matchedElem.getAttribute('data-track-label')
      )
    }
  })
}


/***
 * Carousels
 *
 */
const setCarousel = (rootSelector, options) => {
  const rootElem = document.querySelector(rootSelector)

  if (!rootElem) {
    return
  }

  const carouselElem = rootElem.querySelector('[data-carousel]')
  const prevBtn = rootElem.querySelector('[data-carousel-prev]')
  const nextBtn = rootElem.querySelector('[data-carousel-next]')

  const carouselInstance = carousel(
    carouselElem,
    options,
    nextBtn,
    prevBtn
  )

  carouselInstance.init()

  return carouselInstance
}


/***
 * SVG Store stuff (inline svgs)
 *
 */
const createCustomEvent = (name) => {
  return new CustomEvent(
    name,
    {
      bubbles: true,
      cancelable: true
    }
  )
}

const loadSvgStore = (assetURL) => {
  svgInliner.loadStore(assetURL)
    .then(() => {
      svgInliner.process('[data-inline-svg]', false)

      document.documentElement.dispatchEvent(
        createCustomEvent('svgStoreLoaded')
      )
    })
    .catch(() => {
      console.error('error loading SVG Store', assetURL)
    })
}

const configureSvgStores = (selector) => {
  const targetElems = document.querySelectorAll(selector)

  Array.prototype.forEach.call(targetElems, (elem) => {
    loadSvgStore(
      elem.getAttribute('data-load-svg-store')
    )
  })
}


/***
 * Background video
 *
 */
const setBgVideo = (selector) => {
  const targetElem = document.querySelector(selector)

  if (!targetElem) {
      return
  }

  const video = bgVideo(targetElem)
  video.init()

  return video
}


/***
 * Video modal triggers
 *
 */
const setVideoModalTriggers = (modal, attribute) => {
  document.addEventListener('click', (event) => {
    let matchedElem = dom.eventAttributeMatch(
      event.target,
      event.currentTarget,
      attribute
    )

    if (!matchedElem) {
      return
    }

    event.preventDefault()

    const videoID = matchedElem.getAttribute(attribute)

    modal.setContent(`
      <div class="flexibleIframe">
        <iframe
          src="https://www.youtube.com/embed/${videoID}?rel=0&amp;showinfo=0&amp;autoplay=1&amp;modestbranding=1"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    `)

    modal.open()
  })
}


/***
 * Modals
 *
 */
const setModal = (targetElem) => {
  if (!targetElem) {
    return
  }

  const modal = simpleModal(targetElem)
  modal.setEvents()
  return modal
}


/***
 * Initialise the main app
 *
 */
const initApp = () => {
  es6Promise.polyfill()
  FastClick.attach(document.body)

  configureSvgStores('[data-load-svg-store]')

  const focusStylesObserver = createFocusStylesObserver(document.body)
  focusStylesObserver.start()

  setBgVideo('[data-bg-video]')

  const modal = setModal(
    document.querySelector('[data-modal]')
  )

  setVideoModalTriggers(
    modal,
    'data-video-modal'
  )

  setClickTracking()

  setCarousel('[data-gameplay-gallery-carousel]')
  setCarousel('[data-testimonials-carousel]')
  setCarousel('[data-charcters-carousel]')
}


/***
 * Kick off the app when the DOM is ready
 *
 */
function onDOMReady() {
  initApp()
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  onDOMReady()
} else {
  document.addEventListener('DOMContentLoaded', onDOMReady, false)
}





/** WEBPACK FOOTER **
 ** ./src/scripts/client/app.client.js
 **/